import { DailyProvider } from '@daily-co/daily-react';
import { getCallObject, initializeCallObject } from '@unmoderated/video-service';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { unhandledRequestHandler } from './app/mocks/handlers';
import './app/utils/observability/sentry';
import { queryClient } from './app/utils/queryClient';
import { QueryClientProvider } from '@tanstack/react-query';
import { HotsauceProvider } from '@hotjar/hotsauce';

initializeCallObject();

async function enableMocking() {
  if (!['localhost', '127.0.0.1'].includes(window.location.hostname)) {
    return;
  }

  const { server } = await import('./app/mocks/server');
  return server.start({ onUnhandledRequest: unhandledRequestHandler });
}

enableMocking().then(() => {
  const callObject = getCallObject();

  const container = document.getElementById('root') as HTMLElement;
  const root = createRoot(container);
  root.render(
    <QueryClientProvider client={queryClient}>
      <HotsauceProvider>
        <DailyProvider callObject={callObject}>
          <App />
        </DailyProvider>
      </HotsauceProvider>
    </QueryClientProvider>,
  );
});
